<div class="toast-container">
  <div class="container">
    <ng-container *ngFor="let toast of toasts">
      <air-toast-item class="toast__item toast__item--{{ toast.type }}" [toast]="toast" @slideIn @slideOut></air-toast-item>
    </ng-container>
  </div>
</div>
